import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';
import { ChatImageDeletedPayload } from 'features/chat/types';
import { chatMessageImageRemoved } from 'features/chat/chatSlice';

export function* onChatImageDeletedSaga(action: PayloadAction<ChatImageDeletedPayload>) {
  yield put(chatMessageImageRemoved(action.payload));
}
